import React from 'react'
import { motion } from 'framer-motion'
import { LucideIcon } from 'lucide-react'

interface GradientButtonProps {
  children: React.ReactNode
  onClick?: () => void
  icon?: LucideIcon
  variant?: 'primary' | 'secondary' | 'outline'
  size?: 'sm' | 'md' | 'lg'
  className?: string
  disabled?: boolean
  loading?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const GradientButton: React.FC<GradientButtonProps> = ({
  children,
  onClick,
  icon: Icon,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  loading = false,
  type = 'button',
}) => {
  const variants = {
    primary: 'btn-gold',
    secondary: 'btn-primary',
    outline: 'btn-secondary',
  }

  const sizes = {
    sm: 'text-sm px-5 py-2.5',
    md: 'text-sm sm:text-base px-6 py-3',
    lg: 'text-base px-8 py-3.5',
  }

  return (
    <motion.button
      type={type}
      className={`${variants[variant]} ${sizes[size]} gap-2 ${className} ${
        disabled || loading ? 'opacity-50 cursor-not-allowed hover:translate-y-0' : ''
      }`}
      onClick={onClick}
      disabled={disabled || loading}
      whileTap={!disabled && !loading ? { scale: 0.98 } : {}}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      {loading ? (
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-current" />
      ) : (
        <>
          {Icon && <Icon size={size === 'sm' ? 16 : size === 'md' ? 18 : 20} />}
          <span>{children}</span>
        </>
      )}
    </motion.button>
  )
}

export default GradientButton
